import { closeSnackbar, enqueueSnackbar, SnackbarProvider, } from 'notistack';
import React from 'react';
import { ToastIcon, ToastStyled, ToastTypography, ToastWrapper } from './toast.styles';
export class Toast {
    constructor(message, options = {}) {
        this.message = message;
        this.options = options;
    }
    static info(message, options = {}) {
        return new Toast(message, {
            ...options,
            variant: 'info',
        }).open();
    }
    static success(message, options = {}) {
        return new Toast(message, {
            ...options,
            variant: 'success',
        }).open();
    }
    static error(message, options = {}) {
        return new Toast(message, {
            ...options,
            variant: 'error',
        }).open();
    }
    open() {
        this.key = enqueueSnackbar(this.message, {
            variant: 'info',
            ...this.options,
        });
        return this;
    }
    close() {
        this.key && closeSnackbar(this.key);
        return this;
    }
}
Toast.closeAll = () => closeSnackbar();
const icons = {
    success: 'check-circle-filled',
    error: 'alert-circle-filled',
};
export const Bread = React.forwardRef((props, ref) => {
    const { 
    // You have access to notistack props and options 👇🏼
    id, message, variant, icon, } = props;
    const toastIcon = icon || icons[variant];
    return (React.createElement(ToastStyled, { ref: ref, role: "alert" },
        React.createElement(ToastWrapper, { variant: variant },
            toastIcon && React.createElement(ToastIcon, { name: toastIcon, size: "s" }),
            React.createElement(ToastTypography, null, message))));
});
Bread.displayName = 'Bread';
export const ToastProvider = ({ children }) => {
    return React.createElement(SnackbarProvider, { autoHideDuration: 5000, Components: {
            info: Bread,
            success: Bread,
            error: Bread,
        }, maxSnack: 1 }, children);
};
export default Toast;
//# sourceMappingURL=toast.js.map